import { TextFilterType } from '../../../../../types';
import { TeamNewFinStatus } from '../../../../../main/teams/teamsTypes';

export type UniversalFilterCompanyNewFinStatusStatus = TeamNewFinStatus;

export const enum UniversalFilterCompanyNewFinStatusModes {
  IS_ANY_OF = 'is_any_of',
  IS_NONE_OF = 'is_none_of'
}

export type UniversalFilterCompanyNewFinStatusValue = TextFilterType;

export type UniversalFilterCompanyNewFinStatusFilterState = {
  mode: UniversalFilterCompanyNewFinStatusModes;
  statuses?: UniversalFilterCompanyNewFinStatusStatus[];
};

export type UniversalFilterCompanyNewFinStatusOnFilterStateChange = (
  state: UniversalFilterCompanyNewFinStatusFilterState
) => void;

export type UniversalFilterCompanyNewFinStatusOnChange = (
  value?: UniversalFilterCompanyNewFinStatusValue
) => void;
